<template>
  <div class="col-md-12 p-0">
    <div class="white-card">
      <div class="white-card-header">
        <div class="title-wrap">
          <label class="title-label">{{label.get('overview')}}</label>
        <!--  <i class="atto info-icon"
             id="tooltip-overview"
          />
          <b-tooltip
              target="tooltip-overview"
              custom-class="info-tooltip"
              placement="bottom" >
              <label>Overview</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
          </b-tooltip>-->
        </div>

      </div>
      <div class="overview-table">
        <div class="d-flex flex-row">
          <div class="d-flex flex-column table-col border-r">
            <label>{{ overviewData[0].label }}</label>
            <span>{{ overviewData[0].value }}</span>
          </div>
          <div class="d-flex flex-column table-col border-r">
            <label>{{ overviewData[2].label }}</label>
            <span>{{ overviewData[2].value }}</span>
          </div>
          <div class="d-flex flex-column table-col border-r">
            <label>{{ overviewData[4].label }}</label>
            <span>{{ overviewData[4].value }}</span>
          </div>
          <div class="d-flex flex-column table-col">
            <label>{{ overviewData[6].label }}</label>
            <span>{{ overviewData[6].value }}</span>
          </div>
        </div>
        <div class="d-flex flex-row border-t">
          <div class="d-flex flex-column table-col border-r">
            <label>{{ overviewData[1].label }}</label>
            <span>{{ overviewData[1].value }}</span>
          </div>
          <div class="d-flex flex-column table-col border-r">
            <label>{{overviewData[3].label}}</label>
            <span>{{overviewData[3].value}}</span>
          </div>
          <div class="d-flex flex-column table-col border-r">
            <label>{{overviewData[5].label}}</label>
            <span>{{overviewData[5].value}}</span>
          </div>
          <div class="d-flex flex-column table-col">
            <label>{{ overviewData[7].label }}</label>
            <span>{{ overviewData[7].value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "TimesheetOverviewComponent",
    props: {
      overview: {
        type: Array,
        default: []
      },
    },
    computed: {
      overviewData() {
        if(this.overview !== undefined && this.overview !== null && this.overview.length > 0) {
          return this.overview;
        }

        return [{
          label: this.label.get('total_hours'),
          value: "-"
        },{
          label: this.label.get('regular_hours'),
          value: "-"
        },{
          label: this.label.get('overtime'),
          value: "-"
        },{
          label: this.label.get('double_overtime'),
          value: "-"
        },{
          label: this.label.get('paid_break'),
          value: "-"
        },{
          label: this.label.get('unpaid_break'),
          value: "-"
        },{
          label: this.label.get('paid_time_off'),
          value: "-"
        },{
          label: this.label.get('unpaid_time_off'),
          value: "-"
        }];
      }
    }
  }

</script>

